interface HandleDescopeSignInSuccessParams {
  onMissingSessionJwt: () => void;
  onSignIn: (descopeToken: string) => Promise<unknown>;
  sessionJwt: string | undefined;
}

export const handleDescopeSignInSuccess = async ({
  onMissingSessionJwt,
  onSignIn,
  sessionJwt,
}: HandleDescopeSignInSuccessParams): Promise<void> => {
  if (!sessionJwt?.trim()) {
    onMissingSessionJwt();
    return;
  }

  await onSignIn(sessionJwt);
};
